import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Demo_Product.css";

import { Link, useNavigate } from "react-router-dom";

import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Common_Category_Card from "../../common-components/common_category_card/Common_Category_Card";

function Demo_ProductCategory({
  products,
  breakpoints,
  setSelectId,
  selectId,
}) {
  const navigate = useNavigate();
  return (
    <section className="Demo_Product_holder">
      <div className="container">
        <div className="category_swiper_holder">
          <div className="heading_holder">
            <h4 className="heading_text">Shop our top categories</h4>
          </div>

          <div className="all_cats_div">
            <div className="row">
              {products?.map((product, index) => (
                <div className="col-xl-2 col-md-3 col-sm-4 col-6">
                  <div className="card_holder">
                    <Common_Category_Card
                      imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                      title={product.name}
                      onClick={() =>
                        navigate(`/categories?category_id=${product?.id}`)
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/*old code  */}
          {/* <Swiper
            modules={[Pagination, Navigation]}
            navigation={true}
            spaceBetween={10}
            slidesPerView={4}
            pagination={{ clickable: true }}
            breakpoints={breakpoints}
            className=""
          >
            {products?.map((product, index) => (
              <SwiperSlide key={index}>
                <div className="Demo_Product">
                  <div className="product-card">
                    <div
                      className="img_holder"
                      onClick={() =>
                        navigate(`/categories?category_id=${product?.id}`)
                      }
                    >
                   
                      <img
                        className="Product_img"
                        src={process.env.REACT_APP_IMG_URL + product.image}
                        alt={product.name}
                      />
                 
                    </div>

                    <p className="product-name">{product.name}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper> */}
        </div>
      </div>
    </section>
  );
}

export default Demo_ProductCategory;
